import Image from "next/image";

import { Paragraph } from "@/components/ui/typography";
import { RadioGroupItem } from "@radix-ui/react-radio-group";

import { cn } from "@/lib/utils";

function OfflineCenter({ centre }) {
  return (
    <RadioGroupItem
      className={cn(
        "group flex items-center gap-x-4 p-3",
        "border border-grayscale-input hover:border-primary-weak rounded-lg",
        "data-[state=checked]:bg-primary-bg data-[state=checked]:border-primary"
      )}
      value={centre.offlineCentreId}
    >
      <div
        className={cn(
          "flex items-center justify-center size-15 rounded-lg bg-grayscale-weak p-2.5 shrink-0",
          "group-data-[state=checked]:bg-primary group-data-[state=checked]:text-primary-foreground"
        )}
      >
        <Image
          src={centre.offlineCentreIcon}
          alt={centre.offlineCentreName}
          width={60}
          height={60}
          className="group-data-[state=checked]:brightness-0 group-data-[state=checked]:invert-100"
        />
      </div>

      <Paragraph variant="b3" weight="sb" className="line-clamp-2">
        {centre.offlineCentreName}
      </Paragraph>
    </RadioGroupItem>
  );
}

export default OfflineCenter;
